// Utility to handle redirecting users back to their last visited step/process upon login
// Excludes public auth pages, home page, as well as eSign and eNACH steps.

const LAST_VISITED_URL_KEY = "oxy_last_visited_url";

// Preserve last visited URL across localStorage.clear() calls (e.g. during logout)
if (typeof window !== "undefined" && window.localStorage) {
  const originalClear = Storage.prototype.clear;
  Storage.prototype.clear = function () {
    let savedUrl = null;
    try {
      savedUrl = this.getItem(LAST_VISITED_URL_KEY);
    } catch (e) {
      // ignore
    }
    originalClear.call(this);
    if (savedUrl) {
      const lower = savedUrl.toLowerCase();
      if (!lower.includes("esign") && !lower.includes("enach") && !lower.includes("/login")) {
        try {
          this.setItem(LAST_VISITED_URL_KEY, savedUrl);
        } catch (e) {
          // ignore
        }
      }
    }
  };
}

/**
 * Saves the current path as the last visited URL if it is a valid process/step page.
 * @param {string} pathname 
 * @param {string} search 
 */
export const saveLastVisitedUrl = (pathname, search = "") => {
  if (!pathname) return;

  const excludedPaths = [
    "/",
    "/login",
    "/loginotp",
    "/admlogin",
    "/register",
    "/userType",
    "/borrower_register",
    "/register_active_proceed",
    "/oxyIntro",
    "/forgotpassword",
    "/forgotpassword2",
    "/whatsappuser",
    "/whatsapplogin",
    "/whatappuser",
    "/partnerRegister",
    "/partnerLogin",
  ];

  const lowerPath = pathname.toLowerCase();

  // Do NOT save auth/public routes or eSign & eNACH routes
  if (
    excludedPaths.includes(pathname) ||
    lowerPath.includes("esign") ||
    lowerPath.includes("enach")
  ) {
    return;
  }

  const fullUrl = pathname + (search || "");
  try {
    localStorage.setItem(LAST_VISITED_URL_KEY, fullUrl);
  } catch (e) {
    console.error("Could not save last visited URL to localStorage", e);
  }
};

/**
 * Retrieves the saved redirect URL after login and clears it from storage.
 * Falls back to defaultPath if no valid saved URL exists or if it was esign/enach.
 * @param {string} defaultPath 
 * @returns {string} Target URL to navigate to
 */
export const getPostLoginRedirectUrl = (defaultPath = "/borrowerDashboard") => {
  try {
    const savedUrl = localStorage.getItem(LAST_VISITED_URL_KEY);
    if (savedUrl) {
      // Always remove it once retrieved so user goes to default on subsequent fresh logins
      localStorage.removeItem(LAST_VISITED_URL_KEY);

      const lower = savedUrl.toLowerCase();
      // Ensure excluded paths (esign/enach/login) are never returned
      if (
        !lower.includes("esign") &&
        !lower.includes("enach") &&
        !lower.includes("/login") &&
        !lower.includes("/admlogin")
      ) {
        return savedUrl;
      }
    }
  } catch (e) {
    console.error("Error retrieving last visited URL", e);
  }
  return defaultPath;
};
